import curry from 'lodash.curry';
import createAction from './createAction';

export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/createCurriedAction.js
// module id = ./node_modules/redux-actions/es/createCurriedAction.js
// module chunks = 6 9 11